﻿function setFuelTypeButtons() {
    setTimeout(
        function () {
            const url = window.location.href.split('?')[1];
            if(!url)
                return;
            const selectedFuelTypeArray = url.split('=');
            const selectedFuelType = selectedFuelTypeArray[selectedFuelTypeArray.length - 1];
            if (selectedFuelType.indexOf(',') > 1) {
                const stringArray = selectedFuelType.split(',');
                stringArray.forEach(function (item) {
                    const buttonTarget = `data-fuel-type-${item}`;
                    $(`[${buttonTarget}]`).removeClass().addClass("btn btn-green");
                });
            } else {
                const buttonTarget = `data-fuel-type-${selectedFuelType}`;
                $(`[${buttonTarget}]`).removeClass().addClass("btn btn-green");
            }
        }, 5000);
}

export function setupFuelTypeButtons() {
    window.fuelTypeButtons = setFuelTypeButtons
    window.fuelTypeButtons();
}
